import { useMutation, useQueryClient } from 'react-query';
import {
  type AddUserProfileBody,
  type AddUserProfileResponse,
  addUserProfile
} from '../../services/userProfileService';

export function useAddUserProfile() {
  const queryClient = useQueryClient();
  return useMutation<AddUserProfileResponse, Error, AddUserProfileBody>(
    (body) => addUserProfile(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('users');
        queryClient.invalidateQueries('userProfile');
        queryClient.invalidateQueries('V1:UserProfilesList');
        queryClient.invalidateQueries(['buddyPreference']);
      }
    }
  );
}
